export var CMG_ACCOUNT_TYPE = 'CMG';
//# sourceMappingURL=ally-bank.js.map